export default "__VITE_PUBLIC_ASSET__5e96bbba__"